export default __webpack_public_path__ + "static/media/shop-04.999ac822.png";